import { useCallback, useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { ModalContext } from './ModalProvider';
import { FormModalOptions, Id, ModalOptions } from './types';

const useFormModal = (id: Id = uuidv4()) => {
  const ctx = useContext(ModalContext);

  if (!ctx) {
    throw Error('The `useFormModal` hook must be called from a descendent of the `ModalProvider`.');
  }
  const showModal = useCallback((options: FormModalOptions) =>
    ctx.show({...options, type:'form', id}),
  [ctx.show]);

  const hideModal = useCallback(() =>
    ctx.hide(id),
  [ctx.show]);

  return [showModal, hideModal];
};


export default useFormModal;
